/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	CompanyDTO,
	CompanyDTOFromJSON,
	CompanyDTOFromJSONTyped,
	CompanyDTOToJSON,
} from "./CompanyDTO";

/**
 *
 * @export
 * @interface CompanyDTOPagedResponse
 */
export interface CompanyDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<CompanyDTO>}
	 * @memberof CompanyDTOPagedResponse
	 */
	data?: Array<CompanyDTO> | null;
}

export function CompanyDTOPagedResponseFromJSON(
	json: any
): CompanyDTOPagedResponse {
	return CompanyDTOPagedResponseFromJSONTyped(json, false);
}

export function CompanyDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(CompanyDTOFromJSON),
	};
}

export function CompanyDTOPagedResponseToJSON(
	value?: CompanyDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(CompanyDTOToJSON),
	};
}
